export const HEADER_MESSAGE = `Looks like there are some tickets already open for this table.`;
export const TABLE_NUMBER_TEXT = `You are dining at XXXX`;
export const CONFIRM_BUTTON = `Yes, this is my ticket`;
export const CANCEL_BUTTON = `None of these are my ticket`;
export const NO_TICKET_ERROR_MESSAGE = `Please contact your server to continue`;
export const WARNING = 'warning sign';
